export default {
	isLoading: state => !state.hasRoomData,
	isIncorrectVersion: state => state.hasRoomData && state.roomData.version !== process.env.VUE_APP_FIREBASE_VERSION,
	isRoomEmpty: state => state.hasRoomData && state.players.length == 0,
	isInRoom: state => state.hasRoomData && state.players.some(player => player.username == state.username),
	isRoomLeader: state => state.hasRoomData && state.players.some(player => player.username == state.username && player.isLeader),
	sortedPlayersByPoints: state => {
		let players = state.players.slice()

		players.sort((a, b) => {
			let diff = Math.max(-1, Math.min(1, b.points - a.points))

			if (diff == 0) {
				diff = a.username.toLowerCase().localeCompare(b.username.toLowerCase())
			}

			return diff
		})

		return players
	},
	userRole: state => {
		if (state.hasRoomData) {
			let player = state.players.find(player => player.username == state.username)

			if (player && player.role) {
				return player.role
			}
		}

		return ''
	},
	leaderUsername: state => {
		if (state.hasRoomData) {
			let leader = state.players.find(player => player.isLeader)

			if (leader) {
				return leader.username
			}
		}

		return ''
	},
	mafiaUsername: state => {
		if (state.hasRoomData) {
			let mafia = state.players.find(player => player.role == 'mafia')

			if (mafia) {
				return mafia.username
			}
		}

		return ''
	},
	canVotePlayer: (state, getters) => player => {
		return getters.isInRoom
			&& state.roomData.isStarted
			&& !state.roomData.isComplete
			&& getters.userRole == 'villager'
			&& player.username != state.username
	},
	hasUserVoted: state => state.hasRoomData && state.votes.some(vote => vote.voter == state.username)
}
